import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import {
  WrapperStyled,
  DetailContainerStyled,
  ContainerStyled,
  ContentStyled,
  SectionStyled,
} from 'modules/detail/styled';

import {
  getJobDetail,
  getJobDetailData,
  getShipperOrderAssignmentId,
  submodalOpened,
  submodalParams,
  getJobDetailError,
} from 'redux/modules/job-detail/selectors';

import {
  assignJourney,
  assignShipperOrderWithBreak,
  closeShipperOrderAssignment,
  closeEditCost,
  saveEditCost,
  closeAssigmentModal,
} from 'redux/modules/job-detail/effects';

import JourneyEditModal from 'modules/journey/EditModal';

import { Assignment } from 'modules/Common/Detail/submodals';

import ActionDecisionModal from 'modules/journey/ActionDecisionModal';

import { CargoManifest, CargoManifestDelete } from 'modules/journey/detail/submodals';

import DocumentsModal from 'modules/shipper-order/Documents/DocumentsModal';

import JourneyMap from 'modules/journey/map/Modal';
import CancellationReasons from 'modules/cancellation-reasons';

import {
  detailMounted as journeyDetailMounted,
  detailUnmounted as journeyDetailUnmounted,
} from 'redux/modules/job-detail/effects';

import { isUploadDocumentsModalOpened } from 'redux/modules/shipper-order-documents/selectors';

import ShipperOrdersSection from './sections/shipper-orders';
import JourneyInfoSection from './sections/journey-info';
import StopsSection from './sections/stops';
import HeaderSection from './sections/header';
import ErrorSection from './sections/error';
import JourneySidebar from './sections/journey-sidebar';

import { getSidebarTabs } from 'utils/journey';

const JobDetail = ({
  journey,
  showCloseButton,
  closeURL,
  showBackButton,
  fetching,
  assignJourney,
  shipperOrderAssignmentId,
  assignShipperOrderWithBreak,
  closeShipperOrderAssignment,
  closeEditCost,
  saveEditCost,
  submodalOpened,
  submodalParamsObject,
  closeAssigmentModal,
  journeyDetailMounted,
  journeyDetailUnmounted,
  match: {
    params: { id },
  },
  error,
  isUploadDocumentsModalOpened,
}) => {
  useEffect(() => {
    journeyDetailMounted({ id });
    return () => {
      journeyDetailUnmounted();
    };
  }, [journeyDetailUnmounted, journeyDetailMounted, id]);

  const sidebarTabs = getSidebarTabs({
    status: (journey || {}).status,
    route: (journey || {}).route,
  });

  return (
    <>
      <DetailContainerStyled>
        <WrapperStyled>
          <HeaderSection
            showBackButton={showBackButton}
            showCloseButton={showCloseButton}
            closeURL={closeURL}
          />
          {!!error ? (
            <ErrorSection error={error} />
          ) : (
            <ContainerStyled>
              <ContentStyled>
                <SectionStyled flex="0 1 17rem" p="S">
                  <JourneyInfoSection fetching={fetching} />
                </SectionStyled>
                <SectionStyled flex="0 1 20rem" background="grey300" p="S">
                  <ShipperOrdersSection fetching={fetching} />
                </SectionStyled>
                <SectionStyled flex="1" background="grey800" p="S">
                  <StopsSection fetching={fetching} />
                </SectionStyled>
              </ContentStyled>
            </ContainerStyled>
          )}
        </WrapperStyled>
        <JourneySidebar defaultTab="LOGS" tabsToDisplay={sidebarTabs} />
      </DetailContainerStyled>

      <ActionDecisionModal />

      {submodalOpened === 'assignment' && (
        <Assignment item={journey} onClose={closeAssigmentModal} assign={assignJourney} />
      )}

      {!!shipperOrderAssignmentId && (
        <Assignment
          item={journey}
          onClose={closeShipperOrderAssignment}
          assign={assignShipperOrderWithBreak}
        />
      )}

      {submodalOpened === 'uploadcargo' && <CargoManifest params={submodalParamsObject} />}

      {submodalOpened === 'deletecargo' && <CargoManifestDelete params={submodalParamsObject} />}

      {submodalOpened === 'edit_cost' && (
        <JourneyEditModal journey={journey} onSave={saveEditCost} onClose={closeEditCost} />
      )}

      {submodalOpened === 'view_cost' && (
        <JourneyEditModal
          journey={journey}
          onSave={saveEditCost}
          onClose={closeEditCost}
          readOnly
        />
      )}

      {isUploadDocumentsModalOpened && <DocumentsModal />}

      <JourneyMap />
      <CancellationReasons />
    </>
  );
};

const actionCreators = {
  assignJourney,
  assignShipperOrderWithBreak,
  closeShipperOrderAssignment,

  closeEditCost,
  saveEditCost,
  closeAssigmentModal,

  journeyDetailMounted,
  journeyDetailUnmounted,
};

export default connect((state) => {
  const jobDetail = getJobDetail(state);
  return {
    journey: getJobDetailData(state),
    opened: jobDetail.opened,
    fetching: jobDetail.fetching,
    shipperOrderAssignmentId: getShipperOrderAssignmentId(state),
    submodalOpened: submodalOpened(state),
    submodalParamsObject: submodalParams(state),
    error: getJobDetailError(state),
    isUploadDocumentsModalOpened: isUploadDocumentsModalOpened(state),
  };
}, actionCreators)(JobDetail);
